import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('TaskItem').create(({ theme }) => ({
  root: {
    display: 'flex',
    gap: '12px',
    position: 'relative',
    cursor: 'pointer',
    alignItems: 'flex-start',

    height: '76px',

    width: '100%',
    '&[data-iscompleted="true"] ': {
      pointerEvents: 'none',
    },
    '&[data-loading="true"] ': {
      pointerEvents: 'none',
      opacity: '0.8',
    },
    '&[data-iscompleted="true"] > *': {
      opacity: '0.4',
    },

    '&[data-pinned="true"]': {
      backgroundColor: '#2E2F34',

      '&:active': {
        backgroundColor: '#27292e',
      },
      '&:last-child': {
        height: '82px',
      },
    },
    transition: 'background-color 0.3s',
    '&:active': {
      backgroundColor: '#27292e',
    },
    '&[data-issteamon="true"]': {
      backgroundColor: 'rgba(96, 125, 252, 0.20)',
    },
  },

  iconWrapper: {
    display: 'flex',
    paddingLeft: '16px',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
  },

  textWrapper: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    paddingRight: '10%',
    width: '100%',

    // maxWidth: '73%',

    gap: '2px',
    '&[data-center="true"]': {
      justifyContent: 'center',
      alignItems: 'center',
    },
    '&[data-center="false"]': {
      justifyContent: 'center',
      alignItems: 'flex-start',
      paddingTop: '4px',
    },
    '&[data-pinned="false"]': {
      paddingRight: '12%',
    },
    '&[data-isnews="true"]': {
      paddingRight: '2%',
    },
  },

  taskIcon: {
    width: '40px',
  },

  headingWrapper: {
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    // justifyContent: 'space-between',
    alignSelf: 'flex-start',
    gap: '8px',
  },

  heading: {
    display: 'inline-block',
    fontWeight: 350,
    fontSize: theme.sizes.texts.fontSize.m,
    lineHeight: '20px',
    color: theme.colors.text.primary,

    '&[data-ellipsis="true"]': {
      whiteSpace: 'nowrap',
      maxWidth: '55%',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },

    '&[data-isnews="true"]': {
      width: '100%',
      fontSize: '16px',
      textWrap: 'nowrap',
    },
  },

  description: {
    display: 'block',
    width: '90%',
    alignSelf: 'flex-start',
    fontWeight: 350,
    lineHeight: theme.sizes.texts.lineHeight.s,

    textAlign: 'start',
    wordWrap: 'break-word',
    fontSize: '12px',
    color: theme.colors.text.secondary,

    '&[data-isnews="true"]': {
      width: '100%',
    },
  },

  throbberWrapper: {
    position: 'absolute',
    right: '16px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
  },

  counterWrapper: {
    position: 'absolute',
    right: '8px',
    display: 'flex',
    alignItems: 'center',
    height: '100%',
  },

  counterField: {
    fontWeight: 600,
    fontSize: theme.sizes.texts.fontSize.s,
    lineHeight: theme.sizes.texts.lineHeight.s,

    textAlign: 'right',
    color: theme.colors.text.primary,
  },
}))
